import { withResourceState } from '@kinet-open-network/client/shared/data-access/state';
import { signalStore } from '@ngrx/signals';
import { TagsService } from '../services/tags.service';

export const TagsStore = signalStore(
  { protectedState: false },
  withResourceState(TagsService),
);
